/**
 * One location asking another for stock — "I need this, this and that from
 * the warehouse." Deliberately small: three locations, one business, so this
 * mirrors the order state machine's shape rather than inventing a new one.
 *
 * `in_transit` is left out on purpose for v1: `accepted` already covers "the
 * other side is getting it ready", and `fulfilled` covers "it moved" — there
 * is no one to press a separate "it's on the way" button in a three-location
 * shop. Adding it later is a cheap enum append if that changes.
 */
export const STOCK_REQUEST_STATUSES = [
    'requested',
    'accepted',
    'declined',
    'fulfilled',
    'cancelled',
];
/** Truly final — nothing follows any of these. */
export const TERMINAL_STOCK_REQUEST_STATUSES = [
    'declined',
    'fulfilled',
    'cancelled',
];
export const STOCK_REQUEST_TRANSITIONS = {
    requested: ['accepted', 'declined', 'cancelled'],
    accepted: ['fulfilled', 'cancelled'],
    declined: [],
    fulfilled: [],
    cancelled: [],
};
export function canTransitionStockRequest(from, to) {
    return STOCK_REQUEST_TRANSITIONS[from].includes(to);
}
//# sourceMappingURL=stock-request-states.js.map